import tinycolor from 'tinycolor2';

/**
 * 将协议中argb格式转为rgba格式
 * @param str
 * @returns
 */
export function toRgba(str: string) {
  const color = str?.replace('#', '') ?? '';
  let _str = '';
  if (color.length == 8) {
    _str = '#' + color.slice(2) + color.slice(0, 2);
  } else {
    _str = str;
  }
  return _str;
}

/**
 * 将rgba格式格式转为协议中argb
 * @param str
 * @returns
 */
export function toArgb(str: string) {
  const color = str?.replace('#', '') ?? '';
  let _str = '';
  if (color.length == 8) {
    _str = '#' + color.slice(6) + color.slice(0, 6);
  } else {
    _str = str;
  }
  return _str;
}
/**
 * 获取rgba格式rgb
 * @param str
 * @returns
 */
export function toRgb(str: string) {
  const color = str?.replace('#', '') ?? '';
  let _str = '';
  if (color.length > 6) {
    _str = '#' + color.slice(0, 6);
  } else {
    _str = str;
  }
  return _str;
}

export const recolor = (
  ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
  size: {
    x: number;
    y: number;
    width: number;
    height: number;
  },
  color: string
) => {
  const { x, y, width, height } = size;
  const { r, g, b } = tinycolor(color).toRgb();
  // 获取图片的像素数据
  const imageData = ctx.getImageData(x, y, width, height);
  const data = imageData?.data ?? [];
  // 循环遍历每个像素，将符合要求的像素颜色更改为新的颜色
  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] == 0) continue;
    data[i] = (r * data[i]) / 255;
    data[i + 1] = (g * data[i + 1]) / 255;
    data[i + 2] = (b * data[i + 2]) / 255;
  }
  // 将更改后的像素数据重新绘制到canvas上
  if (imageData) ctx.putImageData(imageData, x, y);
};
